@if (visible) {
	<div [@slideInOut]>
		<ng-content></ng-content>
	</div>
}
